import React from 'react'
import { NoticeLoading } from '@fs/zion-icon'
import styles from './LoadingSpinner.styles'

// This component is a copy of the AuthRoute spinner: https://github.com/fs-webdev/zion/blob/master/packages/router/src/AuthRoute.js
export default function LoadingSpinner() {
  return (
    <div data-testid="spinner" css={styles.center}>
      <NoticeLoading size="lg" />
    </div>
  )
}
